import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import { Grid, Button, Modal } from "@mui/material";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";
import { ReactComponent as IconExpadion } from "../../../assets/icons/iconExpadion.svg";

const OBJECT_IDS = {
  COBERTURA_BASE_TABLE: "ejBSj",
};

const LojasNaoPositivadas = ({ app, onDetailClick, isLoading }) => {

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const [sellOutRegionalSO, setSellOutRegionalSO] = useState("");

    useEffect(() => {
      let isMounted = true;
      let variableModel = null;

      // Função para atualizar o título com o valor atual da variável
      const updateTitle = async () => {
        try {
          variableModel = await app.variable.getByName("vTexto_Regional_SO");
          const layout = await variableModel.getLayout();
          if (isMounted) {
            setSellOutRegionalSO(layout.qText);
          }
        } catch (error) {
          console.error("Erro ao obter a variável:", error);
        }
      };

      // Chama a função para obter o valor inicial da variável
      updateTitle();

      // Adiciona um listener para detectar mudanças na variável
      const addVariableListener = async () => {
        try {
          variableModel = await app.variable.getByName("vTexto_Regional_SO");
          variableModel.on("changed", updateTitle);
        } catch (error) {
          console.error("Erro ao adicionar listener à variável:", error);
        }
      };

      addVariableListener();

      // Cleanup: remove o listener quando o componente for desmontado
      return () => {
        isMounted = false;
        if (variableModel) {
          variableModel.removeListener("changed", updateTitle);
        }
      };
    }, [app]);

  return (
    <>
      <Grid container className="container-cards-kpi">
        <Card
          app={app}
          className={"card-kpi-item"}
          header={{
            hardTitle: `${sellOutRegionalSO}`,
          }}
          expandable
          exportContainer
          exportTable
          exportTableId={OBJECT_IDS.COBERTURA_BASE_TABLE}
        >
          <Button
            className="detail-button"
            variant="outlined"
            onClick={handleOpenModal}
            endIcon={<IconExpadion />}
            disabled={isLoading}
          />
          <NativeObject
            app={app}
            key={OBJECT_IDS.COBERTURA_BASE_TABLE}
            style={{ width: "100%", height: "55vh" }}
            reference={{ id: OBJECT_IDS.COBERTURA_BASE_TABLE }}
            className={"table-item-ranking"}
          />
        </Card>
      </Grid>

      <Modal open={openModal} onClose={handleCloseModal}>
        <Grid
          className="card"
          flexDirection="column"
          justifyContent="center"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "92vw",
            height: "90vh",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflow: "hidden",
          }}
        >
          <NativeObject
            app={app}
            key={OBJECT_IDS.COBERTURA_BASE_TABLE}
            reference={{ id: OBJECT_IDS.COBERTURA_BASE_TABLE }}
            style={{ width: "100%", height: "100%" }}
          />
        </Grid>
      </Modal>
    </>
  );
};

LojasNaoPositivadas.propTypes = {
  app: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default LojasNaoPositivadas;
